import { Route } from '@angular/router';

export const commissionInvoiceRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./list/commission-invoice-list.component').then(
        (m) => m.CommissionInvoiceListComponent
      ),
  },
  {
    path: 'create',
    loadComponent: () =>
      import('./create/commission-invoice-create.component').then(
        (m) => m.CommissionInvoiceCreateComponent
      ),
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./detail/commission-invoice-detail.component').then(
        (m) => m.CommissionInvoiceDetailComponent
      ),
  },
];
